"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { CircleAlert as AlertCircle, ArrowRight } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ReplacementParts() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="replacementpartsvalue" data-nav="light" className="w-full bg-background text-foreground py-16 md:py-24 px-4 sm:px-6 lg:px-8 border-b border-border">
      <div className="max-w-4xl mx-auto">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1,
        y: 0
      } : {
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: shouldReduceMotion ? 0 : 0.3,
        ease: "easeOut"
      }} className="border-2 border-border bg-card text-card-foreground p-6 sm:p-10 md:p-12 relative shadow-xs">
          {/* Heading */}
          <div className="space-y-4 mb-8">
            <h2 className="font-serif text-2xl sm:text-3xl md:text-4xl font-bold uppercase tracking-tight text-foreground">
              Replacement Parts Can Change the Value of a Used Machine
            </h2>
            <div className="h-0.5 w-16 bg-primary" />
          </div>

          {/* Advisory Copy Blocks */}
          <div className="space-y-5 text-base sm:text-lg leading-relaxed text-muted-foreground font-sans">
            <div className="flex items-start gap-3 bg-muted/40 p-4 border-l-2 border-primary">
              <AlertCircle className="size-5 text-primary shrink-0 mt-0.5" />
              <p className="font-medium text-foreground">
                A used mechanical bull may appear inexpensive until an unavailable component needs replacing.
              </p>
            </div>

            <p>
              Before purchasing older equipment, think about future access to controllers, switches, sensors, inflatable components, blowers, electrical components and model-specific replacement parts.
            </p>

            <p>
              This is particularly important for commercial operators because equipment downtime can be more costly than the component itself.
            </p>
          </div>

          {/* Industrial Action Bar */}
          <div className="mt-10 pt-8 border-t border-border flex items-center justify-end">
            <Button asChild size="lg" className="w-full sm:w-auto bg-primary hover:bg-primary/90 text-primary-foreground font-sans font-semibold uppercase tracking-wider text-xs px-6 py-3 rounded-none shadow-sm transition-colors group">
              <Link to="/MechanicalBullPartsAndAccessoriesPage">
                Browse parts & accessories
                <ArrowRight className="size-4 ml-2 transition-transform duration-200 group-hover:translate-x-1" />
              </Link>
            </Button>
          </div>
        </motion.div>
      </div>
    </section>;
}